import { Component, OnDestroy } from '@angular/core';
import { BPProfilesService } from './bp-profiles.service';

@Component({
  selector: 'bp-profiles',
  template: '<ui-view ></ui-view>'
})
export class BPProfilesComponent implements OnDestroy {
  constructor(
    private bpProfilesService:BPProfilesService
  ) {
    /**/
  }

  public ngOnDestroy():void {
    this.bpProfilesService.clear();
  }
}